import { Component, OnDestroy, OnInit } from '@angular/core';
import { HasChanges } from '../services/HasChanges';
import { Subject } from 'rxjs/internal/Subject';
import { FormGroup } from '@angular/forms';
import { BriefingService, TenantService, EventService } from '../services';
import { BehaviorSubject } from 'rxjs';
import { flatMap } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as moment from 'moment';

@Component({
    template: `
        <div fxLayout="column">
            <mat-toolbar>
                <h3>Create Briefing</h3>
                <span fxFlex></span>
                <button mat-raised-button color="primary" [disabled]="form?.invalid || !hasChanges()" (click)="save()">Save</button>
            </mat-toolbar>
            <briefing-editor [form]="form" [topic$]="briefingStreams$"></briefing-editor>
        </div>
    `
})
export class CreateBriefingPaneComponent implements HasChanges, OnInit, OnDestroy {
    form: FormGroup;
    hasSaved: boolean;
    briefingStreams$ = new BehaviorSubject<any[]>([]);
    cleanupTime$ = new Subject<void>();

    constructor(private briefingService: BriefingService,
                private eventService: EventService,
                private tenantService: TenantService,
                private route: ActivatedRoute, 
                private router: Router, 
                private snackBar: MatSnackBar) {}

    ngOnInit(): void {
        this.form = this.briefingService.buildBriefingForm(this.cleanupTime$);
        this.form.patchValue({
            type: this.route.snapshot.params.type === 'EMAIL' ? 'SENDGRID' : this.route.snapshot.params.type, 
            schedule: {
                scheduleMode: 'MANUAL',
                timeZone: 'US/Pacific', 
                freq: 'DAILY',
                endMode: 'NEVER_ENDS',
                sendTime: moment().hours(7).minutes(0).millisecond(0).toDate(),
                interval: 1 
            }
        });
    }

    hasChanges(): boolean {
        return !this.hasSaved && this.form.touched;
    }    
    
    existingChangesMessage(): string {
        return 'Continue and lose changes?';
    }

    save(): void {
        const briefing = Object.assign({}, this.form.value, {
            streamIds: this.briefingStreams$.value.map(stream => stream.id),
        });
        briefing.schedule = Object.assign({}, briefing.schedule, {
            manual: briefing.schedule.scheduleMode === 'MANUAL',
            recurring: briefing.schedule.scheduleMode !== 'MANUAL',
            interval: 1,
            endMode: 'NEVER_ENDS',
            start: briefing.schedule.start || moment().toDate()
        });
        
        this.tenantService.getUnauthTenantInfo()
        .pipe(
            flatMap(tenant => {
                this.eventService.postEvent('briefing_created');
                briefing.published = tenant.settings.autoBriefingPublish === 'true' || briefing.published;
                return this.briefingService.createBriefing(briefing);
            })
        )
        .subscribe(() => {
            this.snackBar.open('Briefing Created.', 'OK', { duration: 3000});
            this.hasSaved = true;
            this.router.navigate(['/settings', 'briefings']);
        });
    }

    ngOnDestroy(): void {
        this.cleanupTime$.next();
        this.cleanupTime$.complete();
    }
}    